module.exports = __webpack_public_path__ + "static/img/ohc-python.b75494d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/oneHourCode/ohc-python.gif
// module id = tdmg
// module chunks = 1